<template>
    <b-form-modal title="Editar Usuário" @submit="onSubmit">

        <b-message type="is-warning">Atenção: esta alteração só terá efeito na próxima vez que este usuário acessar o
            sistema
        </b-message>

        <b-field label="Permissões do Usuário">
            <b-select v-model="formData.accountType" required>
                <option value="client">Cliente</option>
                <option value="admin">Administrador</option>
            </b-select>
        </b-field>

        <button type="submit" class="button is-primary is-rounded" slot="footer">Salvar</button>
    </b-form-modal>
</template>

<script>

import database from "@/services/database";

export default {
    name: "editUser",

    props: {
        action: {
            type: String,
            default: 'create'
        },
        id: {
            default: null
        },
        setData: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            formData: {
                accountType: 'client'
            }
        }
    },

    methods: {

        updateFormData(newData) {
            const formData = {};
            for (const formDataKey in this.formData) {
                const newDataValue = newData[formDataKey];
                formData[formDataKey] = newDataValue !== undefined ? newDataValue : null;
            }

            this.formData = formData;
        },

        async loadData() {
            const id = this.id;
            if (id) {
                const loading = this.$buefy.loading.open();
                const document = await database.collection('users').doc(id).get();
                this.updateFormData(document.data());

                loading.close();
            }
        },

        async onSubmit() {
            const loading = this.$buefy.loading.open();
            const formData = this.formData;
            await database.collection('users').doc(this.id).set(formData, {merge: true});
            this.$emit('onSave', {id: this.id, data: formData});

            loading.close();
        }
    },

    created() {
        if (this.id) {
            this.loadData();
        }

        if (this.setData) {
            this.updateFormData(this.setData);
        }
    }
}
</script>
